export const SIX_MINUTE_WALK_SESSION_STORAGE_PREFIX = "pdx.sixMinuteWalk.v1";

export function buildSixMinuteWalkSessionStorageKey(uid) {
  return `${SIX_MINUTE_WALK_SESSION_STORAGE_PREFIX}:${uid || "anonymous"}`;
}

export function clearStoredSixMinuteWalkAssessment(uid) {
  if (!uid || typeof window === "undefined") {
    return;
  }

  try {
    window.sessionStorage.removeItem(buildSixMinuteWalkSessionStorageKey(uid));
  } catch {}
}
